import { DocumentSearchItem } from '@/entities/DocumentsSearch';

export type DocumentSearchSortBy = 'relevance' | 'date';

export const sortDocumentSearchItems = (
  items: readonly DocumentSearchItem[],
  sortBy: DocumentSearchSortBy,
): DocumentSearchItem[] => {
  const copy = [...items];

  if (sortBy === 'date') {
    return copy.sort((a, b) => {
      if (!a.createdAt && !b.createdAt) {
        return 0;
      }
      if (!a.createdAt) {
        return 1;
      }
      if (!b.createdAt) {
        return -1;
      }

      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }

  return copy.sort((a, b) => {
    if (a.combinedScore === null && b.combinedScore === null) {
      return 0;
    }
    if (a.combinedScore === null) {
      return 1;
    }
    if (b.combinedScore === null) {
      return -1;
    }

    return b.combinedScore - a.combinedScore;
  });
};
